import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-link',
    styleUrls: ['./link.component.scss'],
    templateUrl: './link.component.html',
    standalone: false
})
export class LinkComponent implements OnInit {

  @Input() public href: string;
  @Input() public external: boolean;

  constructor() { }

  public get icon(): string {
    return this.external ? '#icon-external' : '#icon-chevron-right';
  }

  public get target(): string {
    return this.external ? '_blank' : '_self';
  }

  public ngOnInit() {
  }

}
